module.exports = __webpack_public_path__ + "static/seller/img/seo-l.8aabef70.png";